import Message from "../../message";
import {useMainStore} from "@/store";

export default class SeasonPointsGained extends Message
{
    handle()
    {
        useMainStore().INCREMENT_SEASON_POINTS({
            id: this.message.competitor_id,
            points: this.message.points,
        });
    }
}
